import axiosClient from "./axiosClient";

// Bỏ tham số rỗng trước khi ghép query — tránh gửi status=&campId= làm BE lọc nhầm.
const buildQuery = (params = {}) => {
    const entries = Object.entries(params).filter(([, v]) => v !== "" && v != null);
    const qs = new URLSearchParams(entries).toString();
    return qs ? `?${qs}` : "";
};

/** API admin Chương trình thưởng (backend /admin-reward-program, permission campaign_x2). */
const rewardProgramApi = {
    // Danh sách type + configFields để form render động
    getTypes() {
        return axiosClient.get("admin-reward-program/types");
    },
    list() {
        return axiosClient.get("admin-reward-program");
    },
    // Dán link shop/sản phẩm → BE tách id (whitelist đợt). entity: 'shop' | 'product'.
    resolveLinks(links, entity) {
        return axiosClient.post("admin-reward-program/resolve-links", { links, entity });
    },
    // Gõ tay id sản phẩm → BE tra tên + ảnh để điền sẵn ô "Tên (ghi chú)".
    lookupItem({ campId, entity, productId, url }) {
        return axiosClient.post("admin-reward-program/lookup-item", { campId, entity, productId, url });
    },
    // Tìm shop theo tên trong đơn đã crawl — TikTok bắt buộc dùng (không link nào ra shop_code).
    searchShops(campId, q) {
        return axiosClient.get(`admin-reward-program/shop-search${buildQuery({ campId, q })}`);
    },
    // Ước lượng đợt đang điền: chạy cấu hình nháp qua engine chốt lô với đơn N ngày
    // gần nhất (chỉ đọc, không tạo đợt).
    estimate(data, days = 30) {
        return axiosClient.post("admin-reward-program/estimate", { ...data, days });
    },
    create(data) {
        return axiosClient.post("admin-reward-program", data);
    },
    update(id, data) {
        return axiosClient.put(`admin-reward-program/${id}`, data);
    },
    remove(id) {
        return axiosClient.delete(`admin-reward-program/${id}`);
    },
    clone(id) {
        return axiosClient.post(`admin-reward-program/${id}/clone`);
    },
    // Đối soát phân bổ: rows (đã phân trang ở server) + totals toàn đợt + options lọc
    allocations(id, params = {}) {
        return axiosClient.get(`admin-reward-program/${id}/allocations${buildQuery(params)}`);
    },
    // Export CSV toàn đợt theo bộ lọc. Phải đi qua axios (token nằm ở header
    // Authorization — mở URL thẳng bằng window.open sẽ bị 401).
    allocationsCsv(id, params = {}) {
        return axiosClient.get(`admin-reward-program/${id}/allocations.csv${buildQuery(params)}`, {
            responseType: "blob",
        });
    },
    // Số liệu tab Tổng quan: totals theo status + diễn biến theo ngày + thống kê đăng ký
    overview(id) {
        return axiosClient.get(`admin-reward-program/${id}/overview`);
    },
    // Danh sách người đăng ký đợt (lọc/phân trang server)
    participants(id, params = {}) {
        return axiosClient.get(`admin-reward-program/${id}/participants${buildQuery(params)}`);
    },
    // Export CSV người đăng ký theo bộ lọc đang xem
    participantsCsv(id, params = {}) {
        return axiosClient.get(`admin-reward-program/${id}/participants.csv${buildQuery(params)}`, {
            responseType: "blob",
        });
    },
    // userId của tập đang lọc — nạp sẵn vào form Push (audience mode 'ids')
    participantUserIds(id, params = {}) {
        return axiosClient.get(`admin-reward-program/${id}/participants/ids${buildQuery(params)}`);
    },
    // Đơn của 1 user trong đợt (mở rộng dòng)
    participantOrders(id, userId) {
        return axiosClient.get(`admin-reward-program/${id}/participants/${userId}/orders`);
    },
    // Upload thumbnail/banner (field 'image') → { filename, url }
    uploadImage(file) {
        const formData = new FormData();
        formData.append("image", file);
        return axiosClient.post("admin-reward-program/upload-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};

export default rewardProgramApi;
